<h2 mat-dialog-title>Trocar Senha</h2>

<mat-dialog-content>
  <div class="password-fields">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Senha atual</mat-label>
      <input
        matInput
        [(ngModel)]="currentPassword"
        [type]="showCurrent ? 'text' : 'password'"
        placeholder="Digite sua senha atual"
        autocomplete="current-password"
      />
      <button
        mat-icon-button
        matSuffix
        type="button"
        (click)="showCurrent = !showCurrent"
        [attr.aria-label]="showCurrent ? 'Ocultar senha' : 'Exibir senha'"
      >
        <mat-icon>{{ showCurrent ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Nova senha</mat-label>
      <input
        matInput
        [(ngModel)]="newPassword"
        [type]="showNew ? 'text' : 'password'"
        placeholder="Mínimo 6 caracteres"
        autocomplete="new-password"
      />
      <button
        mat-icon-button
        matSuffix
        type="button"
        (click)="showNew = !showNew"
        [attr.aria-label]="showNew ? 'Ocultar senha' : 'Exibir senha'"
      >
        <mat-icon>{{ showNew ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
      <mat-hint *ngIf="newPassword && newPassword.length < 6" class="hint-error">
        Mínimo 6 caracteres
      </mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Confirmar nova senha</mat-label>
      <input
        matInput
        [(ngModel)]="confirmPassword"
        [type]="showConfirm ? 'text' : 'password'"
        placeholder="Repita a nova senha"
        autocomplete="new-password"
      />
      <button
        mat-icon-button
        matSuffix
        type="button"
        (click)="showConfirm = !showConfirm"
        [attr.aria-label]="showConfirm ? 'Ocultar senha' : 'Exibir senha'"
      >
        <mat-icon>{{ showConfirm ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
      <mat-hint *ngIf="confirmPassword && !passwordsMatch" class="hint-error">
        As senhas não coincidem
      </mat-hint>
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()" [disabled]="loading">
    Cancelar
  </button>
  <button
    mat-raised-button
    color="primary"
    type="button"
    (click)="onSubmit()"
    [disabled]="!isFormValid || loading"
  >
    <mat-spinner *ngIf="loading" diameter="18" style="display:inline-block; margin-right:6px;"></mat-spinner>
    Salvar
  </button>
</mat-dialog-actions>
